import { Component, EventEmitter, HostBinding, input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { WebchatStatusComponent } from '../webchat-status/webchat-status.component';
import { DefaultPosition } from '../../models/webchat-config';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'webchat-button',
  imports: [CommonModule, MatButtonModule, WebchatStatusComponent, TranslateModule],
  templateUrl: './webchat-button.component.html',
  styleUrls: ['./webchat-button.component.scss'],
})
export class WebchatButtonComponent {
  @Output() clicked = new EventEmitter<void>();
  hideStatus = input<boolean>(true);
  position = input<'right' | 'left'>(DefaultPosition);

  backgroundColor = input<string>('');
  iconColor = input<'light' | 'dark'>('light');

  toggleChat(): void {
    this.clicked.emit();
  }

  @HostBinding('style.--icon-color') get styleIconColor() {
    return this.iconColor() === 'light' ? 'white' : 'black';
  }
}
